import { useTranslation } from 'react-i18next';
import { namedOperations, useAllAdvertiserPicsQuery } from '@anytag/graphql';
import { AccountUsersList } from '../../Accounts';

export interface AdvertiserUsersListProps {
  advertiserId: number;
}

export const AdvertiserUsersList = ({ advertiserId }: AdvertiserUsersListProps) => {
  const { t } = useTranslation();
  const { data, loading } = useAllAdvertiserPicsQuery({ variables: { advertiserId } });

  return (
    <AccountUsersList
      loading={loading}
      data={data?.allAdvertiserPics || []}
      title={t<string>('Accessible Users')}
      refetchQueriesAfterDelete={[namedOperations.Query.AllAdvertiserPics]}
    />
  );
};
